import { css } from "@emotion/react";

export const addStyles = location => css`
  position: absolute;
  padding-top: 21px;
  z-index: 9;
  width: auto;

  ${location === "base" &&
  css`
    top: 100%;
    right: 0;
  `}

  ${location === "left" &&
  css`
    top: -22px;
    right: 100%;
  `}
  
  ${location === "leftHalf" &&
  css`
    top: -22px;
    right: 50%;
  `}
  
  ${location === "top" &&
  css`
    top: -22px;
    right: 0;
  `}
`;
